/**
 * When the user last interacted with the admin, for the idle sign-out.
 *
 * Kept in `localStorage`, unlike the session, so every open tab shares one
 * clock: working in one tab keeps the others signed in, and a tab left idle
 * does not revoke the refresh token another tab is still using. It holds a
 * timestamp only — never a token.
 */

const STORAGE_KEY = 'dc-admin-last-activity';

export function saveLastActivity(at: number = Date.now()): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(at));
  } catch {
    // Storage blocked. The tab still tracks its own activity in memory.
  }
}

export function loadLastActivity(): number | null {
  try {
    const value = Number(localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
}
